export default "__VITE_ASSET__DrJk7N5Y__"